var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dropzone", attrs: { id: "dropzone_id" + this.unq_id_gen } },
    [
      _c("div", [
        _c("div", { staticClass: "fallback" }, [
          _c("input", {
            attrs: { type: "file", name: _vm.file_name, multiple: "true" }
          })
        ]),
        _vm._v(" "),
        _c("div", {
          staticClass: "dropzone-previews row",
          attrs: { id: "dropzone_preview" + this.unq_id_gen }
        }),
        _vm._v(" "),
        _c("div", [
          _c("div", { attrs: { id: "vx_left_side" + this.unq_id_gen } }),
          _vm._v(" "),
          _c("div", [
            _c("div", { attrs: { id: "drop_msg" + this.unq_id_gen } }, [
              _c("div", {
                staticClass: "dz-message",
                attrs: { "data-dz-message": "" }
              })
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "vx_dropzone_template",
            attrs: { id: "vx_dropzone_template" + this.unq_id_gen }
          },
          [
            _c("div", { staticClass: "vx-file-tabs" }, [
              _c("div", { staticClass: "vx dz-preview dz-file-preview" }, [
                _vm._m(0),
                _vm._v(" "),
                _vm._m(1),
                _vm._v(" "),
                _vm._m(2),
                _vm._v(" "),
                _vm._m(3),
                _vm._v(" "),
                _c("div", { staticClass: "vx dz-success-mark" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "54px",
                        height: "54px",
                        viewBox: "0 0 54 54",
                        version: "1.1",
                        xmlns: "http://www.w3.org/2000/svg",
                        "xmlns:xlink": "http://www.w3.org/1999/xlink",
                        "xmlns:sketch":
                          "http://www.bohemiancoding.com/sketch/ns"
                      }
                    },
                    [
                      _c("title", [_vm._v("Check")]),
                      _vm._v(" "),
                      _c("desc", [_vm._v("Created with Sketch.")]),
                      _vm._v(" "),
                      _c("defs"),
                      _vm._v(" "),
                      _c(
                        "g",
                        {
                          attrs: {
                            id: "Page-1" + this.unq_id_gen,
                            stroke: "none",
                            "stroke-width": "1",
                            fill: "none",
                            "fill-rule": "evenodd",
                            "sketch:type": "MSPage"
                          }
                        },
                        [
                          _c("path", {
                            attrs: {
                              d:
                                "M23.5,31.8431458 L17.5852419,25.9283877 C16.0248253,24.3679711 13.4910294,24.366835 11.9289322,25.9289322 C10.3700136,27.4878508 10.3665912,30.0234455 11.9283877,31.5852419 L20.4147581,40.0716123 C20.5133999,40.1702541 20.6159315,40.2626649 20.7218615,40.3488435 C22.2835669,41.8725651 24.794234,41.8626202 26.3461564,40.3106978 L43.3106978,23.3461564 C44.8771021,21.7797521 44.8758057,19.2483887 43.3137085,17.6862915 C41.7547899,16.1273729 39.2176035,16.1255422 37.6538436,17.6893022 L23.5,31.8431458 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z",
                              id: "Oval-2" + this.unq_id_gen,
                              "stroke-opacity": "0.198794158",
                              stroke: "#747474",
                              "fill-opacity": "0.816519475",
                              fill: "#FFFFFF",
                              "sketch:type": "MSShapeGroup"
                            }
                          })
                        ]
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "vx dz-error-mark" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "54px",
                        height: "54px",
                        viewBox: "0 0 54 54",
                        version: "1.1",
                        xmlns: "http://www.w3.org/2000/svg",
                        "xmlns:xlink": "http://www.w3.org/1999/xlink",
                        "xmlns:sketch":
                          "http://www.bohemiancoding.com/sketch/ns"
                      }
                    },
                    [
                      _c("title", [_vm._v("error")]),
                      _vm._v(" "),
                      _c("desc", [_vm._v("Created with Sketch.")]),
                      _vm._v(" "),
                      _c("defs"),
                      _vm._v(" "),
                      _c(
                        "g",
                        {
                          attrs: {
                            id: "Page-1" + this.unq_id_gen,
                            stroke: "none",
                            "stroke-width": "1",
                            fill: "none",
                            "fill-rule": "evenodd",
                            "sketch:type": "MSPage"
                          }
                        },
                        [
                          _c(
                            "g",
                            {
                              attrs: {
                                id: "Check-+-Oval-2" + this.unq_id_gen,
                                "sketch:type": "MSLayerGroup",
                                stroke: "#747474",
                                "stroke-opacity": "0.198794158",
                                fill: "#FFFFFF",
                                "fill-opacity": "0.816519475"
                              }
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d:
                                    "M32.6568542,29 L38.3106978,23.3461564 C39.8771021,21.7797521 39.8758057,19.2483887 38.3137085,17.6862915 C36.7547899,16.1273729 34.2176035,16.1255422 32.6538436,17.6893022 L27,23.3431458 L21.3461564,17.6893022 C19.7823965,16.1255422 17.2452101,16.1273729 15.6862915,17.6862915 C14.1241943,19.2483887 14.1228979,21.7797521 15.6893022,23.3461564 L21.3431458,29 L15.6893022,34.6538436 C14.1228979,36.2202479 14.1241943,38.7516113 15.6862915,40.3137085 C17.2452101,41.8726271 19.7823965,41.8744578 21.3461564,40.3106978 L27,34.6568542 L32.6538436,40.3106978 C34.2176035,41.8744578 36.7547899,41.8726271 38.3137085,40.3137085 C39.8758057,38.7516113 39.8771021,36.2202479 38.3106978,34.6538436 L32.6568542,29 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z",
                                  id: "Oval-2" + this.unq_id_gen,
                                  "sketch:type": "MSShapeGroup"
                                }
                              })
                            ]
                          )
                        ]
                      )
                    ]
                  )
                ])
              ])
            ])
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "vx dz-image" }, [
      _c("img", { attrs: { "data-dz-thumbnail": "" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "vx dz-detailin" }, [
      _c("div", { staticClass: "vx dz-filename" }, [
        _c("span", { attrs: { "data-dz-name": "" } })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "vx dz-size" }, [
        _c("span", { attrs: { "data-dz-size": "" } })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "vx dz-progress" }, [
      _c("span", {
        staticClass: "dz-upload",
        attrs: { "data-dz-uploadprogress": "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "vx dz-error-message" }, [
      _c("span", { attrs: { "data-dz-errormessage": "" } })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }